import React from 'react';
import type Overview from '@atlassian/jira-spa-apps-admin-pages-performance-overview/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyOverview = lazyForPaint<typeof Overview>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-system-performance-overview", jiraSpaEntry: "async-system-performance-overview" */ '@atlassian/jira-spa-apps-admin-pages-performance-overview'
		),
	),
);

const AsyncOverview = (): React.JSX.Element => (
	<LazyPage Page={LazyOverview} pageId="system-performance-overview" shouldShowSpinner />
);

export default AsyncOverview;
